

export class CompanyLicenseDetailsOutputWithoutStatus implements ICompanyLicenseDetailsOutputWithoutStatus {
    /** The auto-generated id of the company license details master */
    company_license_details_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The license issue date with 10 character limit */
    license_issue_date!: string;
    /** The license activation date with 10 character limit */
    license_activation_date!: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date!: string;
    /** The license extended date with 10 character limit */
    license_extend_date!: string;
    /** Max vehicle number of company */
    max_vehicles!: number;
    /** Expiry message in days */
    show_expiry_message!: number;
    /** The remark with 500 character limit */
    remark!: string;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The contact person with 255 character limit */
    contact_person!: string;
    /** The help desk number with 13 character limit */
    help_desk_number!: string;
    /** The total vehicle count */
    added_vehicle!: number;

    constructor(data?: ICompanyLicenseDetailsOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_license_details_id = _data["company_license_details_id"];
            this.company_details_id = _data["company_details_id"];
            this.license_issue_date = _data["license_issue_date"];
            this.license_activation_date = _data["license_activation_date"];
            this.license_expiry_date = _data["license_expiry_date"];
            this.license_extend_date = _data["license_extend_date"];
            this.max_vehicles = _data["max_vehicles"];
            this.show_expiry_message = _data["show_expiry_message"];
            this.remark = _data["remark"];
            this.company_name = _data["company_name"];
            this.contact_person = _data["contact_person"];
            this.help_desk_number = _data["help_desk_number"];
            this.added_vehicle = _data["added_vehicle"];
        }
    }

    static fromJS(data: any): CompanyLicenseDetailsOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyLicenseDetailsOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_license_details_id"] = this.company_license_details_id;
        data["company_details_id"] = this.company_details_id;
        data["license_issue_date"] = this.license_issue_date;
        data["license_activation_date"] = this.license_activation_date;
        data["license_expiry_date"] = this.license_expiry_date;
        data["license_extend_date"] = this.license_extend_date;
        data["max_vehicles"] = this.max_vehicles;
        data["show_expiry_message"] = this.show_expiry_message;
        data["remark"] = this.remark;
        data["company_name"] = this.company_name;
        data["contact_person"] = this.contact_person;
        data["help_desk_number"] = this.help_desk_number;
        data["added_vehicle"] = this.added_vehicle;
        return data; 
    }
}

export interface ICompanyLicenseDetailsOutputWithoutStatus {
    /** The auto-generated id of the company license details master */
    company_license_details_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The license issue date with 10 character limit */
    license_issue_date: string;
    /** The license activation date with 10 character limit */
    license_activation_date: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date: string;
    /** The license extended date with 10 character limit */
    license_extend_date: string;
    /** Max vehicle number of company */
    max_vehicles: number;
    /** Expiry message in days */
    show_expiry_message: number;
    /** The remark with 500 character limit */
    remark: string;
    /** The company name with 255 character limit */
    company_name: string;
    /** The contact person with 255 character limit */
    contact_person: string;
    /** The help desk number with 13 character limit */
    help_desk_number: string;
    /** The total vehicle count */
    added_vehicle: number;
}

